import { IDashMatch } from '@nkr/models/index';

export interface IExtendedDashMatch extends IDashMatch {
    selected: boolean
}